import { render, staticRenderFns } from "./ArtworXDialogue.vue?vue&type=template&id=eda935d8&"
import script from "./ArtworXDialogue.vue?vue&type=script&lang=ts&"
export * from "./ArtworXDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports